import { ModalWrapper } from "../../../components/ModalWrapper";
import { SignalReportSubmissionCard } from "../../../components";
import MetadataAnalysisDataReview from "./MetadataAnalysisDataReview";

export const MetadataAnalysisModal = ({ contentData, onClose }) => {
  const isOpen = !!contentData;

  const handleCloseModal = () => {
    onClose();
  };

  return (
    <ModalWrapper
      title={"Metadata analysis signal"}
      isOpen={isOpen}
      onClose={handleCloseModal}
    >
      <SignalReportSubmissionCard data={contentData} />
      <MetadataAnalysisDataReview data={contentData} withSubHeader />
    </ModalWrapper>
  );
};
